import React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface INewHeadphoneIconProps extends IconPropsType {}

const NewHeadphoneIcon = ({
  size = 16,
  fill = '#3E4360',
  ...props
}: INewHeadphoneIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5 8.00004V11.5C14.5 11.8979 14.342 12.2794 14.0607 12.5607C13.7794 12.842 13.3978 13 13 13H12C11.6022 13 11.2206 12.842 10.9393 12.5607C10.658 12.2794 10.5 11.8979 10.5 11.5V9.00004C10.5 8.60221 10.658 8.22068 10.9393 7.93938C11.2206 7.65807 11.6022 7.50004 12 7.50004H13.4781C13.358 6.13885 12.7339 4.87159 11.728 3.94666C10.7221 3.02173 9.40709 2.50581 8.04063 2.50004H8C6.62782 2.49997 5.30517 3.01283 4.29173 3.93793C3.27828 4.86302 2.64724 6.13354 2.5225 7.50004H4C4.39783 7.50004 4.77936 7.65807 5.06066 7.93938C5.34197 8.22068 5.5 8.60221 5.5 9.00004V11.5C5.5 11.8979 5.34197 12.2794 5.06066 12.5607C4.77936 12.842 4.39783 13 4 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8979 1.5 11.5V8.00004C1.5014 6.71247 1.88476 5.45427 2.60156 4.38468C3.31836 3.31509 4.33638 2.4822 5.52674 1.99144C6.71711 1.50068 8.02632 1.37411 9.28866 1.62774C10.551 1.88138 11.7097 2.50382 12.6181 3.41629C13.2179 4.01898 13.6929 4.73409 14.0158 5.52066C14.3387 6.30722 14.5033 7.14977 14.5 8.00004Z"
      fill={fill}
    />
  </svg>
);

export default NewHeadphoneIcon;
